import { AuthLayout as UIAuthLayout } from '@dawn/ui';
import { Outlet } from 'react-router-dom';

import { useTenantStore } from '@/stores/tenant';

export function AuthLayout() {
  const { company } = useTenantStore();

  const tagline = company?.name
    ? `Sign in to continue to ${company.name}.`
    : 'Sign in to continue to the Dawn Security Platform.';

  return (
    <UIAuthLayout tagline={tagline}>
      <Outlet />
    </UIAuthLayout>
  );
}
